import { render, staticRenderFns } from "./ChannelOrder.vue?vue&type=template&id=0e6a1a34&scoped=true&"
import script from "./ChannelOrder.vue?vue&type=script&lang=js&"
export * from "./ChannelOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6a1a34",
  null
  
)

export default component.exports